export default __webpack_public_path__ + "static/media/NCA.9bf4e8c1.svg";